import React from 'react';
import { ColumnHelper, Row } from '@tanstack/react-table';
import Checkbox from '../Checkbox/Checkbox';

const getRowRange = <TData,>(
  rows: Array<Row<TData>>,
  clickedRowID: string,
  previousClickedRowID: string,
) => {
  const range: Array<Row<TData>> = [];
  const processedRowsMap = {
    [clickedRowID]: false,
    [previousClickedRowID]: false,
  };
  for (const row of rows) {
    if (row.id === clickedRowID || row.id === previousClickedRowID) {
      if ('' === previousClickedRowID) {
        range.push(row);
        break;
      }

      processedRowsMap[row.id] = true;
    }
    if (
      (processedRowsMap[clickedRowID] ||
        processedRowsMap[previousClickedRowID]) &&
      !row.getIsGrouped()
    ) {
      range.push(row);
    }
    if (
      processedRowsMap[clickedRowID] &&
      processedRowsMap[previousClickedRowID]
    ) {
      break;
    }
  }

  return range;
};

export function createSelectionColumn<T = unknown>(
  columnHelper: ColumnHelper<T>,
) {
  let lastSelectedId = '';

  return columnHelper.display({
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        id="select-all"
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={(event) => {
          table.getToggleAllRowsSelectedHandler()(event);
          lastSelectedId = '';
        }}
      />
    ),
    cell: (context) => (
      <>
        <Checkbox
          id={`select-row-${context.row.id}`}
          checked={context.row.getIsSelected()}
          indeterminate={context.row.getIsSomeSelected()}
          onChange={context.row.getToggleSelectedHandler()}
          onClick={(event) => {
            if (event.shiftKey) {
              const { rows, rowsById: rowsMap } = context.table.getRowModel();
              const rowsToToggle = getRowRange(
                rows,
                context.row.id,
                rows.map((r) => r.id).includes(lastSelectedId)
                  ? lastSelectedId
                  : '',
              );
              const isLastSelected =
                !rowsMap[context.row.id]?.getIsSelected() || false;
              rowsToToggle.forEach((row) => row.toggleSelected(isLastSelected));
            }

            lastSelectedId = context.row.id;
          }}
        />
      </>
    ),
    meta: {
      size: 'small',
    },
  });
}
